export default {
  "header.logoLink": "Life Science Innovation Network Japan",
  "header.contact.link.title": "Contact Us",
  "header.youtube.link.title": "YouTube Channel",
  "header.youtube.img.alt": "YouTube",
  "header.facebook.link.title": "Facebook",
  "header.linkedin.link.title": "LinkedIn",
  "header.x.link.title": "X",
  "header.instagram.link.title": "Instagram",
  "header.lifeScience.link.title": "Life Science Building Series",
  "header.lifeScience.img.alt": "Life Science Building Series",
  "header.mitsuiLinkLab.link.title": "Mitsui Link-Lab",
  "header.mitsuiLinkLab.img.alt": "Mitsui Link-Lab",
  "header.lbb.link.title": "LINK-BioBAY TOKYO",
  "header.lbb.img.alt": "LINK-BioBAY TOKYO",
  "header.search.placeholder": "Example： Life science",
};
